import { motion } from "framer-motion";

export default function OurVision() {
    return (
        <section className="vision-merged-section">
            <div className="vision-merged-inner">

                {/* IMAGE – SMALL & SUPPORTING */}
                <motion.div
                    className="vision-image small"
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.7 }}
                    viewport={{ once: true }}
                >
                    <img src="/images/founder.jpg" alt="Founder Vision" />
                </motion.div>

                {/* CONTENT */}
                <motion.div
                    className="vision-content"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={{
                        hidden: {},
                        visible: { transition: { staggerChildren: 0.15 } }
                    }}
                >
                    <motion.span className="vision-tag" variants={fadeUp}>
                        OUR VISION
                    </motion.span>

                    <motion.h2 className="section-heading" variants={fadeUp}>
                        Quality You Can Trust. Nutrition You Can Rely On.
                    </motion.h2>

                    <motion.p variants={fadeUp}>
                        Our vision is to build a future where every household has access
                        to pure, safe, and consistently high-quality pulses.
                    </motion.p>

                    <motion.p variants={fadeUp}>
                        We aim to grow responsibly by strengthening farmer partnerships,
                        adopting sustainable practices, and maintaining strict food safety
                        standards.
                    </motion.p>

                    {/* FOUNDER NOTE – SHORT & UNIQUE */}
                    <motion.div
                        className="vision-founder-note"
                        initial={{ opacity: 0, x: 30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.7 }}
                        viewport={{ once: true }}
                    >
                        <strong>Founder’s Philosophy</strong>
                        <p>
                            “Our focus is not just growth, but trust — built grain by grain.”
                        </p>
                        <span className="founder-signature">— Mr. Raj Kumar Soni</span>
                    </motion.div>

                </motion.div>
            </div>
        </section>
    );
}

/* Reusable animation */
const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: "easeOut" }
    }
};
